import { StoryToPlayFragment } from '@graphql/generated/graphql';
import { StoryPageType } from '../enums';
import { SanitizedStoryPage } from '../types';
import { getMediaType } from './getMediaType';

export const getSanitizedStoryPages = (
    story: StoryToPlayFragment
): SanitizedStoryPage[] => {
    if (!story.StoryPages) return [];

    return [...story.StoryPages]
        .sort((a, b) => {
            if (typeof a.Order === 'number' && typeof b.Order === 'number') {
                return a.Order - b.Order;
            }

            return parseInt(a.id) - parseInt(b.id);
        })
        .map((page) => ({
            type: getMediaType(page.Media!) as StoryPageType,
            storyTitle: story.Title,
            pageTitle: page.Title,
            media: page.Media!,
            looping: page.Looping ?? false,
            text: page.DisplayText,
            ...(page.CallToAction?.length && { ctas: page.CallToAction }),
        }));
};
